<template>
    <div class="layout-container">
        <layout-header/>
        <div class="login-dashboard-hero">
            <img src="../../assets/images/computer-icon-white.svg" alt="Computer Icon">
            <div class="welcome">{{ $t('Welcome to')}}</div>
            <div class="welcome-header">{{$t('The Navitas Dashboard')}}</div>
            <div class="welcome-desc">{{$t('Please click on the tiles below to open your Navitas platform(s)')}}</div>
        </div>
        <div class="login-dashboard-panel">
            <div class="login-dashboard-alert">
                <div class="login-dashboard-alert-header">
                    <div class="login-dashboard-alert-title">
                        <img src="../../assets/images/alert-icon-color.svg" alt="Alert Icon">
                        <span>Update:</span>
                    </div>
                    <img src="../../assets/images/x-icon-grey.svg" alt="X Icon">
                </div>
                <div class="login-dashboard-alert-content">{{$t('From now, you will be required to log in with your email address and password. The username will no longer be used for logging in.')}}
                </div>
            </div>
            <div class="login-dashboard-platforms">
                <login-dashboard-platform :slug="complianceSlug" :loading-state="loadingStatePlatform"/>
                <login-dashboard-platform :slug="dfsSlug" :loading-state="loadingStatePlatform"/>
                <login-dashboard-platform :slug="academySlug" :loading-state="loadingStatePlatform"/>
            </div>
        </div>
        <div class="login-dashboard-footer">
            <span>{{$t('If any of these are not available to you and you would like to purchase them, please reach out to us at')}}</span>
            <a href="">{{$t('hello@navitas.eu.com')}}</a>
        </div>
        <div class="login-dashboard-support">
            <div class="link hide-mobile">
                <img src="../../assets/images/support-icon.svg" alt="Support Icon">
                <a href="tel:08081643773">{{$t('0808 164 3773')}}</a>
            </div>
        </div>
    </div>
</template>

<script>
    import LoginDashboardPlatform from "./LoginDashboardPlatform";
    import LayoutHeader from "../layouts/LayoutHeader";
    import AuthService from "../../new/services/AuthService";

    export default {
        name: "LoginDashboard",
        components: {LayoutHeader, LoginDashboardPlatform},
        computed: {
            complianceSlug() {
                return this.$enums.PlatformSlugEnum.COMPLIANCE;
            },
            dfsSlug() {
                return this.$enums.PlatformSlugEnum.DFS;
            },
            academySlug() {
                return this.$enums.PlatformSlugEnum.ACADEMY;
            },
        },
        data() {
            return {
                initData: {},
                loadingStatePlatform: false,
            }
        },
        methods: {
            logout() {
                this.$bus.emit('logout')
            },
            init() {
                this.loadingStatePlatform = true;

                this.$api.init().then(({data}) => {
                    this.initData = data;
                }).finally(() => {
                    this.loadingStatePlatform = false;
                });
            },
        },
        mounted() {
            if (!AuthService.isLogged()) {
                this.$router.push(this.$enums.RoutePathEnum.LOGIN);
            }

            let action = this.$route.query.action ?? '';

            if (action === 'not-authorized') {
                this.$alerts.error(this.$t('Not authorized'));
                this.$router.push(this.$enums.RoutePathEnum.DASHBOARD);
            }

            if (action === 'logout') {
                this.logout();
            }

            this.init();
        }
    }
</script>